export var getCookie = function getCookie(name) {
  if (typeof window === 'undefined') {
    return null;
  }
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : '';
};